import CollectionCard from "Component/Collection/CollectionCard";
import Footer from "Component/Footer/Footer";
import Header from "Component/Header/Header";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import { Col, Container, FormGroup, Input, Row } from "reactstrap";
import {
  getItemsById,
  getNewCollectionByEmailStart,
  getParticularSellItem,
  getParticularUser,
  getviewCountOwner,
} from "store/actions";
import { Oval } from "react-loader-spinner";
export default function ArtistView(props) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();
  const [email, setEmail] = useState();
  const [collectionByEmail, setCollectionByEmail] = useState([]);
  const [collectionBySearch, setCollectionBySearch] = useState([]);
  const [search, setSearch] = useState("");
  const { sellItem } = useSelector((state) => state?.SellItems);
  const { loading } = useSelector((state) => state?.collections);
  const { particularUser, particularUserLoading } = useSelector(
    (state) => state?.Login
  );
  const backto = () => {
    window.history.back();
  };
  useEffect(() => {
    if (id) {
      dispatch(getParticularSellItem(id));
      dispatch(getParticularUser(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (!particularUser?.email) return;

    const callback = (res) => {
      if (res.status === "success") {
        setCollectionBySearch(res.data);
        setCollectionByEmail(res.data);
      }
    };

    dispatch(
      getNewCollectionByEmailStart({ email: particularUser.email }, callback)
    );
  }, [particularUser?.email]);

  const handleSearch = (e) => {
    const value = e;
    setSearch(e);
  };

  useEffect(() => {
    if (search === "") {
      setCollectionBySearch(collectionByEmail);
    } else {
      setCollectionBySearch(
        collectionByEmail?.filter((item) => {
          return search === ""
            ? item
            : item?.name.toLowerCase().includes(search.toLowerCase());
        })
      );
    }
  }, [search]);

  return (
    <>
      {(loading || particularUserLoading) && (
        <div className="loaderBoxMiane">
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      )}
      <Header />
      <div className="container-fluid profileBox nftview">
        <Row>
          <Col lg={12}>
            <h1>
              <div className="d-inline cursor-pointer" onClick={backto}>
                ARTIST VIEW{" "}
              </div>{" "}
            </h1>
          </Col>
        </Row>
      </div>
      <Container>
        <Row className="pb-5">
          <Col lg={12}>
            <div className="collectionProfile position-relative mt-4">
              <ul className="socialMediaArtist">
                {particularUser?.website && (
                  <li>
                    <a
                      href={particularUser?.website}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="website"></div>
                    </a>
                  </li>
                )}
                {particularUser?.facebookUrl && (
                  <li>
                    <a
                      href={particularUser?.facebookUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="facebook"></div>
                    </a>
                  </li>
                )}
                {particularUser?.instagramUrl && (
                  <li>
                    <a
                      href={particularUser?.instagramUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="instagram"></div>
                    </a>
                  </li>
                )}
                {particularUser?.telegramUrl && (
                  <li>
                    <a
                      href={particularUser?.telegramUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="telegram"></div>
                    </a>
                  </li>
                )}
                {particularUser?.youtubeUrl && (
                  <li>
                    <a
                      href={particularUser?.youtubeUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="youtube"></div>
                    </a>
                  </li>
                )}
                {particularUser?.discordUrl && (
                  <li>
                    <a
                      href={particularUser?.discordUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="discord"></div>
                    </a>
                  </li>
                )}
              </ul>
              <div className="profileBoXIn pb-4">
                <div className="profileImgbx">
                  {/* <img src={(isAuction === true && isArtist === false) ? (sellItem?.owner_id?.profileImage?.link) : (isAuction === false && isArtist === true) ? (artistData?.profileImage?.link) : ""} alt="" /> */}
                  <img src={particularUser?.profileImage?.link} alt="" />
                </div>
              </div>
              <div className="profileCollection">
                <div className="profilecollCont">
                  <h1>
                    {particularUser
                      ? particularUser?.name + " " + particularUser?.lastname
                      : ""}
                  </h1>

                  {/* <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap">
                    {particularUser?.website && <p className="fw-semibold"><i className="fa-light fa-globe"></i> <a target={'_blank'} rel="noreferrer" href={particularUser?.website} > {particularUser?.website}</a> </p>}


                  </div> */}
                  {/* {(artistData?.description || sellItem?.owner_id?.description) && */}
                  <p className="scrollheight"> {particularUser?.description}</p>
                  {/* } */}
                </div>
              </div>
              {/* <p className="profileTextCollView">
                {item?.description}
              </p> */}
            </div>
            <Row className="justify-content-between searchcoll mb-4">
              <Col lg={6}>
                <div className="position-relative ">
                  <Input
                    className="form-control searchInput"
                    placeholder="Search for collections"
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <button className="btn position-absolute end-0 top-0 bottom-0 my-auto border-0">
                    <i className="fa-light fa-magnifying-glass"></i>
                  </button>
                </div>
                {/* <p className="pdecription pdecriptioncol text-start">Showing {collectionBySearch ? collectionBySearch.length : 0} Collections</p> */}
              </Col>
              {/* <Col lg={4}>
                <div className="d-flex align-item-center gap-3">
                  <Input
                    type="select"
                    className="form-control searchInput shadow-none"
                  >
                    <option>Low to High</option>
                    <option>High to Low</option>
                  </Input>
                  <Input
                    type="select"
                    className="form-control searchInput shadow-none"
                  >
                    <option>DAILY</option>
                    <option>WEEKLY</option>
                  </Input>
                  <button className="btn border-0 clearfilter p-0">
                    <i className="fa-solid fa-filter-circle-xmark"></i>
                  </button>
                </div>
              </Col> */}
            </Row>

            <Row>
              {collectionBySearch.length > 0 ? (
                <>
                  {collectionBySearch.map((item, index) => (
                    <Col className="mb-4" key={index} lg={3}>
                      <CollectionCard data={item} />
                    </Col>
                  ))}
                </>
              ) : (
                <div className="text-center d-grid justify-content-center dataNotFound py-5">
                  <img
                    src={"../../images/svg/mpdatanft.svg"}
                    className="mb-4"
                    alt="Create collection"
                  />
                  <h3>No Artist Available</h3>
                </div>
              )}
            </Row>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}
